import { apiService } from './api';
import { CropSubType, CreateCropSubTypeDto, UpdateCropSubTypeDto, Region } from '../types/cropSubTypes';

export const cropSubTypesService = {
  // Get all crop sub-types
  getAll: async () => {
    return apiService.get<CropSubType[]>('/cropsubtypes');
  },

  // Get crop sub-types by crop type
  getByCropType: async (cropTypeId: number) => {
    return apiService.get<CropSubType[]>(`/cropsubtypes/by-crop-type/${cropTypeId}`);
  },

  // Get crop sub-type by ID
  getById: async (id: number) => {
    return apiService.get<CropSubType>(`/cropsubtypes/${id}`);
  },

  // Create new crop sub-type
  create: async (data: CreateCropSubTypeDto) => {
    return apiService.post<CropSubType>('/cropsubtypes', data);
  },

  // Update crop sub-type
  update: async (id: number, data: UpdateCropSubTypeDto) => {
    return apiService.put<CropSubType>(`/cropsubtypes/${id}`, data);
  },

  // Delete crop sub-type
  delete: async (id: number) => {
    return apiService.delete<void>(`/cropsubtypes/${id}`);
  },

  // Search crop sub-types
  search: async (searchTerm: string) => {
    return apiService.get<CropSubType[]>(`/cropsubtypes/search?searchTerm=${encodeURIComponent(searchTerm)}`);
  },
};

// Service for regions (needed for dropdowns)
export const regionsService = {
  // Get all regions
  getAll: async () => {
    return apiService.get<Region[]>('/regions');
  },
};